module.exports = __webpack_public_path__ + "img/yellowCalendarIcon.7a36480b.svg";